import { useDispatch, useSelector } from 'react-redux';
import { branchActions } from '../reducers/branch.reducer';
import { BranchState, RootState } from '../types/store.types';

export const useBranchStore = () => {
  const branchStore = useSelector<RootState, BranchState>((state) => state.branch);
  const dispatch = useDispatch();

  const {
    updateActiveStatus,
    getBranchTableList,
    updateBranchList,
    deleteItemBranchList,
    getSearchedBranchTableList,
    updateSelectedBranchList,
    deleteItemSelectedBranchList,
    updateSelectedBranch,
    getSpecialityItems,
    getServiceArea,
    updateSelectedBranchLocation,
  } = branchActions;

  return {
    branchStore,
    dispatch,
    updateActiveStatus,
    getBranchTableList,
    updateBranchList,
    deleteItemBranchList,
    getSearchedBranchTableList,
    updateSelectedBranchList,
    deleteItemSelectedBranchList,
    updateSelectedBranch,
    getSpecialityItems,
    getServiceArea,
    updateSelectedBranchLocation,
  };
};
